var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{class:{ whitelabeled: _vm.isWhitelabeled },on:{"mounted":_vm.loaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }